import { neutral1, primaryHover } from 'apollo-react/colors';

import { HIERARCHY_COLORS, NODE_NAMES } from '../containers/ProductHierarchy/constants';

export const updateHierarchyById = ({ hierarchy, itemId, newChildren }) => {
  const iterateHierarchy = (product) => {
    if (product.itemId === itemId) {
      const filteredNewChildren = newChildren.filter(
        (newChild) =>
          !product.children.some((productChild) => productChild.itemId === newChild.itemId)
      );

      return { ...product, children: [...product.children, ...filteredNewChildren] };
    }

    return {
      ...product,
      children: product.children.map(iterateHierarchy),
    };
  };

  return hierarchy.map(iterateHierarchy);
};

export const getColorByNodeName = (nodeName) => {
  switch (nodeName) {
    case NODE_NAMES.BRAND:
      return HIERARCHY_COLORS.BRAND;
    case NODE_NAMES.FAMILY:
      return HIERARCHY_COLORS.FAMILY;
    case NODE_NAMES.LINE:
      return HIERARCHY_COLORS.LINE;
    case NODE_NAMES.NODE_NEUTRAL:
      return neutral1;
    case NODE_NAMES.NODE_HOVERED:
    case NODE_NAMES.NODE_SELECTED:
      return primaryHover;
    default:
      return HIERARCHY_COLORS.PRODUCT;
  }
};

const getNodeResult = (result) => {
  const { entityName } = result.node;
  const resultIndex = Object.keys(result.path).findIndex((key) => key === entityName);

  result.path = Object.values(result.path).slice(0, resultIndex);

  return result;
};

export const getNodeInfoById = (hierarchy, nodeId) => {
  const result = { node: {}, path: {} };

  const iterateHierarchy = (hierarchyNode) => {
    result.node = hierarchyNode;
    result.path = { ...result.path, [hierarchyNode.entityName]: hierarchyNode.itemId };

    if (hierarchyNode.itemId === nodeId) {
      return false;
    }

    return hierarchyNode.children.every(iterateHierarchy);
  };

  hierarchy.every(iterateHierarchy);

  return getNodeResult(result);
};

export const getHierarchyLevels = (hierarchy) => {
  const result = {
    [NODE_NAMES.BRAND]: '',
    [NODE_NAMES.FAMILY]: '',
    [NODE_NAMES.LINE]: '',
    [NODE_NAMES.PRODUCT]: '',
  };

  const iterateHierarchy = (product) => {
    result[product.entityName] = product.nodeName;

    if (product.children && product.children.length > 0) {
      product.children.forEach(iterateHierarchy);
    }
  };

  hierarchy.forEach(iterateHierarchy);

  const mappedResult = Object.keys(result).reduce((acc, name) => {
    const value = result[name];

    if (value && typeof value === 'string' && value.trim() !== '') {
      return [...acc, { name, label: value }];
    }

    return acc;
  }, []);

  return mappedResult;
};

export const getSearchOptions = (productChildren) => {
  return productChildren.map((child) => {
    return { label: child.label ? `${child.code} (${child.label})` : child.code, child };
  });
};
